import i18n from 'scoreboard/components/i18n'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import ChartsEditCalendarPeriodRangeView from './charts-edit-calendar-period-range-view'
import appDisplay from 'scoreboard/components/app-display'

const EditBreakdownRangeMenu = BootslideMenu.extend({

	/**
	 * @type ChartDesignerRange
	 */
	model: null,

	/**
	 * @type ChartDesignerBreakdown
	 */
	breakdown: null,

	/**
	 * @type ChartDesigner
	 */
	chartDesigner: null,


	initialize: function (opt = {}) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.breakdown = opt.breakdown
		this.chartDesigner = opt.chartDesigner
	},

	menu: function () {
		let topLevel = []

		let rangeType = this.model.get('type')

		if (rangeType === 'calendar-period' || rangeType === 'calendar-period-grouped') {
			topLevel.push(this.editRangeTarget())
		}

		if (rangeType === 'non-matching') {
			topLevel.push(this.toggleNonMatchingActiveTarget())
		}

		if (rangeType !== 'non-matching') {
			topLevel.push({
				label: i18n.get('common.delete'),
				contentView: new DeleteOption({
					model: this.model,
					breakdown: this.breakdown
				})
			})
		}

		return {
			label: i18n.get('charts.editRange'),
			target: topLevel,
			width: 200
		}
	},

	editRangeTarget: function () {
		return {
			label: 'charts.editRange',
			target: e => {
				e.preventDefault()

				let clonedRange = this.model.clone()
				let clonedBreakdown = this.breakdown.clone()

				let editRangeView = new ChartsEditCalendarPeriodRangeView({
					model: clonedRange,
					breakdown: clonedBreakdown,
					chartDesigner: this.chartDesigner
				})

				appDisplay.dialog(editRangeView)

				this.trigger('done')

				this.listenTo(editRangeView, 'done', () => {
					this.chartDesigner.updateCalendarPeriodBreakdownRange({
						updatedBreakdown: clonedBreakdown,
						updatedRange: clonedRange
					})
				})
			}
		}
	},

	toggleNonMatchingActiveTarget: function () {
		return {
			label: 'common.show',
			contentView: ToggleNonMatchingActiveOption,
			model: this.model
		}
	}
})

const DeleteOption = BootslideMenu.DeleteNode.extend({
	/**
	 * @type ChartDesignerRange
	 */
	model: null,

	/**
	 * @type ChartDesignerBreakdown
	 */
	breakdown: null,

	initialize: function(options = {}) {
		this.breakdown = options.breakdown
	},

	/**
	 * @override
	 */
	doDelete: function () {
		this.breakdown.deleteRange(this.model)
	}
})

const ToggleNonMatchingActiveOption = BootslideMenu.ToggleProperty.extend({
	property: {
		label: 'common.show',
		name: 'active'
	}
})

export default EditBreakdownRangeMenu

EditBreakdownRangeMenu.__filename__ = 'charts/edit/edit-breakdown-range-menu.js'
